export const TIME_TO_CLOSE_MODAL = 3000
